import React, { useEffect, useState, useRef  } from "react";
import { Button, Col, Row } from "reactstrap";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserStruct, UserTypes } from "api";
import { APIClient } from "api/apiCore";
import { Utils } from "helpers/utils";
import WorkplaceEditor from "components/WorkplaceEditor";
import WorkplaceQuill from "components/WorkplaceQuill";
import WorkplaceEditorSimple from "components/WorkplaceEditorSimple";
import SimpleEditor from "components/SimpleEditor";


// import { Utils } from "../../../helpers/utils";
const WelcomeWorkplace = () => {

  // for test
  // const test = useEffect(()=>{
  //   const ar1 = [{id:'1', text:'one'},{id:'2', text:'two'},{id:'3', text:'three'},];
  //   const ar2 = [{id:'3', text:'three'},{id:'4', text:'four'}];
  //   const uniqueMessages = new Map(
  //     [...ar1, ...ar2].map((message) => [message.id, message])
  //   );
  //   const uniqueMessages2 = new Map(
  //     [...ar1, ...ar2].map((message) => [message.id, message])
  //   );    
  //   console.log(uniqueMessages);
  //   console.log('tet');
  // },[]);

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (layout: any) => layout.Layout,
    (state: UserStruct, layout) => ({
      profile: state,
      chatConnectError: layout.chatConnectError,
    })
  );
  const { profile, chatConnectError } = useAppSelector(storeData);
  const fnTest = async () => {
    const api = new APIClient();
    const resp = await api.fnPostForm("/test-post-arg", { name: "john", age: 55 });
    //console.log(resp);
  }
  // console.log(profile);
  //{console.log([chatConnectError, Utils.MSG_CHAT_DISCONNECT, chatConnectError == Utils.MSG_CHAT_DISCONNECT])};

  const CustomEditor = () => {
    const editorRef = useRef<HTMLDivElement>(null);
  
    const formatText = (command: string) => {
      document.execCommand(command, false);
    };
  
    return (
      <div>
        
        <div>
          <button onClick={() => formatText("bold")}>B</button>
          <button onClick={() => formatText("italic")}>I</button>
          <button onClick={() => formatText("foreColor")} style={{ color: "red" }}>A</button>
          <button onClick={() => formatText("insertImage")}>🖼️</button>
        </div>
        <div
          ref={editorRef}
          contentEditable
          style={{
            minHeight: "150px",
            border: "1px solid gray",
            padding: "10px",
          }}
        >
          Type here...
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="chat-welcome-section">
        <Row className="w-100 justify-content-center">
          {/* <Col xxl={5} md={7}> */}
          <Col>
            <div className="p-4 text-center">
              <div className="avatar-xl mx-auto mb-4">
                <div className="avatar-title bg-soft-primary rounded-circle">
                  {/* <i className="bx bxs-message-alt-detail display-4 text-primary m-0"></i> */}
                  <img src="/icons/2s-social.png" width={120}></img>
                </div>
              </div>

              <h4>
                  ยินดีต้อนรับคุณ <span className="text-success">{(profile as any).displayName2}</span> สู่<br/>
                  <span className="text-success">2S WORKPLACE</span>
              </h4>
              <p className="text-muted mb-4 ">
                แหล่งศูนย์กลาง แลกเปลี่ยน แบ่งปัน ติดตาม ข้อมูลต่าง ๆ ภายในองค์กร
              </p>

              {/* <CustomEditor/> */}

              {/* <WorkplaceEditor/> */}
              {/* <TestQuill/> */}
              {/* <WorkplaceEditorSimple/> */}
              {/* <SimpleEditor/> */}

              {chatConnectError && (
                <div className="alert alert-danger fade show global-error text-center" role="alert">
                  {/* <span>{chatConnectError}</span> */}
                  <span dangerouslySetInnerHTML={{ __html: chatConnectError }} />
                  {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> */}
                  {/* {chatConnectError == Utils.MSG_CHAT_DISCONNECT && (<a href="#" onClick={(e) => { e.preventDefault(); window.location.reload(); }}> รีโหลด</a>)} */}
                </div>
              )}

              {/* <button onClick={fnTest}>test</button> */}

              {/* <Button type="button" className="btn btn-primary w-lg">
                Get Started
              </Button> */}
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default WelcomeWorkplace;
